module.exports = __webpack_public_path__ + "static/media/BunburyHerald-devicecomp-min@2x.45f3d6f6.png";